import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Stack, useTheme } from "@mui/material";

import { ProductIdDataState } from "@app/modules/categories/selector";
import { findProductIdBy } from "@app/modules/categories/slice";
import { PATH_DASHBOARD } from "@app/routes/paths";
import { useResponsive } from "@app/hooks";
import { Strings } from "@app/constants";

import { ProductImages } from "./products-images";
import { ProductInfo } from "./products-info";
import { ProductSpecifications } from "./products-specifications";
import { ProductListSection } from "./products-lists-sections";
import { views } from "../slice";

const ProductDetail = () => {
  const handleDoubleCallProfilesDetailsApi = useRef(false);
  const { productId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useResponsive("down", "sm");

  const [selectedCardId, setSelectedCardId] = useState<number | null>(null);

  const productDetailState = useSelector(ProductIdDataState);

  const product = productDetailState?.data;
  const productData = product?.car || {};
  const similarCars = product?.similarCars || [];
  const recommended = product?.recommendedForYou || [];
  const dataToShow = productData?.extraInformation;
console.log('productData>>>', productData);

  useEffect(() => {
    if (handleDoubleCallProfilesDetailsApi.current) return;

    if (productId) {
      dispatch(findProductIdBy({ id: productId }));
      dispatch(views({ carId: productId }));
      handleDoubleCallProfilesDetailsApi.current = true;
    }
  }, [productId]);

  const handleViewDetails = (vehicleId: number) => {
    navigate(`${PATH_DASHBOARD.productDetail}/${vehicleId}`);
  };

  const handleCardSelect = (vehicleId: number) => {
    setSelectedCardId(vehicleId);
  };

  return (
    <Stack>
      <Stack
        px={{ xs: 1, md: 8 }}
        py={2}
        direction={{ xs: "column", md: "row" }}
        gap={4}
      >
        <ProductImages productData={productData} />
        <ProductInfo productData={productData} />
      </Stack>

      <ProductSpecifications data={productData} productId={productId} />

      {similarCars?.length > 0 && (
        <ProductListSection
          title={Strings.productDetail.moreLikeThis}
          items={similarCars}
          selectedCardId={selectedCardId}
          onSelect={handleCardSelect}
          onViewDetails={handleViewDetails}
        />
      )}

      {recommended?.length > 0 && (
        <ProductListSection
          title={Strings.productDetail.recommendedForYou}
          items={recommended}
          selectedCardId={selectedCardId}
          onSelect={handleCardSelect}
          onViewDetails={handleViewDetails}
        />
      )}
    </Stack>
  );
};

export { ProductDetail };
